import { Socket } from './socket'

import type { ValuesType } from 'utility-types'
import type { SocketListener } from './socket'

/** 消息类型 */
export const TOPICS = {
  ASYNC_RESULT: 'broadcast://async_result_event', //任务
  USER_MESSAGE: 'broadcast://user_message', //消息中心
} as const

/** 消息类型 */
export type Topic = ValuesType<typeof TOPICS>

export interface SocketVersionUpdatePayload {
  version: string
  uid: string
}

export class OneShipSocket extends Socket<Topic> {
  static readonly TOPICS = TOPICS

  public connect() {
    const topics = Object.keys(TOPICS).map((name) => TOPICS[name])
    this.registerTopics(topics)
  }

  public onAsyncResult<P = any>(handle: SocketListener<P>) {
    return this.on(TOPICS.ASYNC_RESULT, handle)
  }

  /** socket关闭 */
  public onClose<P = any>(handle: SocketListener<P>) {
    return this.on('closed', handle)
  }

  //消息中心
  public onUseMessage<P = any>(handle: SocketListener<P>) {
    return this.on(TOPICS.USER_MESSAGE, handle)
  }
}
